export default __webpack_public_path__ + "7288a7b85e98fa29a445429199905159.svg";